module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "top"
    }
  }, [_c('div', {
    staticClass: "toplist-page"
  }, [_c('prevheader', {
    attrs: {
      "title": _vm.title
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.load),
      expression: "load"
    }],
    staticClass: "load"
  }, [_c('loading')], 1), _vm._v(" "), _c('scroll', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.load),
      expression: "!load"
    }],
    attrs: {
      "data": _vm.toplist,
      "pullup": _vm.pullup
    },
    on: {
      "scrollToEnd": function($event) {
        _vm.loadmore()
      }
    }
  }, [_c('ul', {
    staticClass: "list-content"
  }, [_vm._l((_vm.toplist), function(list, index) {
    return _c('li', {
      staticClass: "list",
      on: {
        "click": function($event) {
          _vm.fileLink(list, 1, _vm.toplist)
        }
      }
    }, [_c('div', {
      staticClass: "rank"
    }, [(index <= 2) ? _c('span', {
      class: {
        icon: true, icon1: index === 0, icon2: index === 1, icon3: index === 2
      }
    }) : _c('span', {
      staticClass: "text"
    }, [_vm._v(_vm._s(index + 1))])]), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_c('h2', {
      staticClass: "name"
    }, [_vm._v(_vm._s(list.title))]), _vm._v(" "), _c('p', {
      staticClass: "desc"
    }, [_vm._v(_vm._s(list.artist_name) + "-" + _vm._s(list.country))])])])
  }), _vm._v(" "), (!_vm.noneData) ? _c('li', [_c('loading')], 1) : _c('li', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "20px",
      "font-size": "13px"
    }
  }, [_vm._v("没有更多数据")])], 2)])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-577183c8"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/view/toplist.vue
// module id = 205
// module chunks = 1